import {
  SaveOutlined,
} from "@ant-design/icons";
import { Tag,Upload } from "antd";
import axios from "axios";
import {
  Button,
  DeleteButton,
  Form,
  Modal,
  Table,
  TableCard,
  Export
} from "components";
import React, { useEffect, useState } from "react";
import { FaPen, FaPlus, FaDownload, FaCaretRight } from "react-icons/fa6";
import { Link, useLocation, useParams } from "react-router-dom";
import dayjs from "dayjs";
import ImgCrop from 'antd-img-crop';

const sampleData = {
  lastname: 'Doe',
  name: 'John',
  registerno: '1234567890',
  phone: '1234567890', // Assuming it's a string since it's mentioned as type 'number'
  email: 'john.doe@example.com',
  role: 'Админ',
  address: '123 Main Street, City, Country',
  description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis vel lectus ut nisl gravida consequat.',
};

function  Costumer_Detail() {
  const [data, setData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [costumer, setCostumer] = useState([]);
  const [warehouse, setWarehouse] = useState([]);
  const [payment, setPayment] = useState([]);
  const [editData, setEditData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showUploadModal, setshowUploadModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [form] = Form.useForm();
  const { id } = useParams()
  const location = useLocation();

  const status = [

    { label: <Tag color="default">Хүсэлт</Tag>, value: 1 },
    { label: <Tag color="processing">Баталгаажсан</Tag>, value: 2 },
    { label: <Tag color="orange">Хүргэж байна</Tag>, value: 3 },
    { label: <Tag color="success">Тооцоо хаасан</Tag>, value: 4 },
  ];
  useEffect(() => {
    getData(); 
    // getWarehouse();
    // getProducts();
    // getCostumer();
    getPayment();
  }, []);

  const getData = () => {
    setLoading(true);
    axios({
      method: "get",
      url: `customer/${id}`,
    })
      .then((res) => {
        // let tmp = [];
        // res.data.map((item) => tmp.push({ 
        //   ...item, 
        //   deliverydate: dayjs(item.deliverydate),
        //   createdAt: dayjs(item.createdAt),
        //   orderdate: dayjs(item.orderdate),
        //   statusdate: dayjs(item.statusdate),
        //   updatedAt: dayjs(item.updatedAt),
        // }))
        setData(res.data)
      })
      .catch((err) => {})
      .finally(() => setLoading(false));
  };
  const getProducts = () => {
    axios({
      method: "get",
      url: "/products",
    })
      .then((res) => {
        let tmp = [];
        res.data.map((item) =>
          tmp.push({
            value: parseInt(item.id),
            label: item.name,
            text: item.name,
            price: item.price
          })
        );
        setProductData(tmp);
      })
      .catch(() => {});
  };

  const getCostumer = () => {
    axios({
      method: "get",
      url: "/customers",
    })
      .then((res) => {
        let tmp = [];
        res.data.map((item) =>
          tmp.push({
            value: parseInt(item.id),
            label: item.name,
            text: item.name,
          })
        );
        setCostumer(tmp);
      })
      .catch(() => {});
  };
  const getPayment = () => {
    axios({
      method: "get",
      url: "/paymenttypes",
    })
      .then((res) => {
        let tmp = [];
        res.data.map((item) =>
          tmp.push({
            value: parseInt(item.id),
            label: item.name,
            text: item.name,
          })
        );
        setPayment(tmp);
      })
      .catch(() => {});
  };
  const getWarehouse = () => {
    axios({
      method: "get",
      url: "/warehouses",
    })
      .then((res) => {
        let tmp = [];
        res.data.map((item) =>
          tmp.push({
            value: parseInt(item.id),
            label: item.name,
            text: item.name,
          })
        );
        setWarehouse(tmp);
      })
      .catch(() => {});
  };

  const columns = [
    {
      title: "№",
      dataIndex: "No",
      key: "No",
      width: 50,
      align: "center",
      cellRender: (e) => <span>{e.rowIndex + currentPage + 1}</span>,
    },
    {
      title: "Барааны нэр",
      dataIndex: "title",
      key: "title",
      cellRender: ({value, data}) => (
        <div className="flex flex-row">
         <div className="action-cell flex items-center gap-2"><FaCaretRight />
        </div><Link to={`/order/${data?.id}`}>{value}</Link>
        </div>
      )
    },
    {
      title: "Захиалсан огноо",
      dataIndex: "orderdate",
      key: "orderdate",
    },
    {
      title: "Тоо ширхэг",
      dataIndex: "qty",
      key: "qty",
    },
    {
      title: "Төлбөрийн төлөв",
      dataIndex: "paymentid",
      key: "paymentid",
      cellRender:({value, data}) =>(
        <div>{payment.find((item) => item?.value === value)?.label}</div>     
      ) 
    },
    {
      title: "Төлсөн дүн",
      dataIndex: "payedamount",
      key: "payedamount",
    },
    {
      title: "Төлөв",
      dataIndex: "status",
      key: "status",
      cellRender:({value, data}) =>(
        <div>{status.find((item) => item?.value === value)?.label}</div>     
      ) 
    },
    
    // {
    //   title: "Төлөв",
    //   dataIndex: "status",
    //   key: "status",
    //   cellRender:({value, data}) =>(
    //     <div>{status.find((item) => item?.value === value)?.label}</div>     
    //   ) 
    // },
    // {
    //   title: 'Төлөв өөрчлөх',
    //   dataIndex: 'status',
    //   key: 'status',
    //   cellRender: ({ value, data }) => {         
    //   const currentIndex = status.find(item => item.value === value);
    //   const nextOption = status.slice(currentIndex.value);
    //   console.log(nextOption, "nextOption");
    //   return (
    //     <Space size="middle" className="">
        
    //     <Dropdown
    //       overlay={
    //         <Menu onClick={({ key }) => handleChange(key, data)}>
    //           {nextOption.map(option => (
    //               <Item key={option.value}>{option.label}</Item>
    //             ))}
    //         </Menu>
    //       }
    //     >
    //       <a>{currentIndex?.label}
    //         {/* <DownOutlined /> */}
    //       </a>
          
    //     </Dropdown>
    //   </Space>
    //     );
    //   },
    // },
    

    // {
    //     title: 'Огноо',
    //     dataIndex: 'end_date',
    //     key: 'end_date',
    //     cellRender: ({value, data}) => (
    //         <>{dayjs(value).format('YYYY-MM-DD')}</>
    //     )
    // },
    // {
    //   title: "",
    //   dataIndex: "action",
    //   key: "action",
    //   width: 90,
    //   cellRender: ({ value, data }) => (
    //     <div className="action-cell flex items-center gap-2">
    //       <Button
    //         type="ghost"
    //         size="sm"
    //         icon={<FaPen />}
    //         onClick={() => handleEditButton(data)}
    //       />
    //       <DeleteButton onClick={() => handleDelete(data)} />
    //     </div>
    //   ),
    // },
  ];

  const fields = [
    {
      label: "Гарчиг",
      name: "title",
      rules: [{ required: true, message: "Гарчиг оруулна уу" }],
      className: "col-span-6 mb-1",
      inputProps: {},
    }, 
   {
      label: "Харилцагч",
      name: "customerid",
      type: "select",
      // rules: [{required: true, message: 'Харилцагч оруулна уу'}],
      className: "col-span-6 mb-1",
      inputProps: {
        options: costumer,
      },
    },   
     {
      label: "Төлбөрийн төрөл",
      name: "paymentid",
      type: "select",
      // rules: [{required: true, message: 'Харилцагч оруулна уу'}],
      className: "col-span-6 mb-1",
      inputProps: {
        options: payment,
      },
    },
    {
      label: "Төлсөн дүн",
      name: "payedamount",
      type: "number",
      // rules: [{required: true, message: 'Төлсөн дүн оруулна уу'}],
      className: "col-span-6 mb-1",
      inputProps: {},
    },
  

    {
      label: "Төлөв",
      name: "status",
      type: "select",
      // rules: [{required: true, message: 'Төлөв оруулна уу'}],
      className: "col-span-4 mb-1",
      inputProps: {
        options: status,
      },
    },
    {
      label: "Захиалгын огноо",
      name: "orderdate",
      type: "date",
      // rules: [{ required: true, message: 'Захиалгын огноо оруулна уу' }],
      className: "col-span-4 mb-1",
      inputProps: {},
    },
    {
      label: "Хүргэсэн огноо",
      name: "deliverydate",
      type: "date",
      // rules: [{ required: true, message: 'Хүргэсэн огноо оруулна уу' }],
      className: "col-span-4 mb-1",
      inputProps: {},
    },
    {
      label: "Тайлбар",
      name: "description",
      type: "textarea",
      // rules: [{ required: true, message: 'Тайлбар оруулна уу' }],
      className: "col-span-12 mb-1",
      inputProps: {},
    },
  
  ];
  const fieldsUpload = [
    {
      label: "Зураг",
      name: "image",
      type:'image',
      className: "col-span-12 mb-1",
      inputProps: {},
    }, 
 
  ];
  const handleSubmit = (values) => {
    setActionLoading(true);
    if (editData) {
      axios({
        method: "put",
        url: `/order`,
        data: {
          ...values,
          id: parseInt(editData.id),
        },
      })
        .then((res) => {
          getData();
          handleCancel();
        })
        .catch((err) => {})
        .finally(() => {
          setActionLoading(false);
        });
    } else {
      axios({
        method: "post",
        url: `/order`,
        data: {
          ...values
        },
      })
        .then((res) => {
          getData();
          handleCancel();
        })
        .catch((err) => {})
        .finally(() => {
          setActionLoading(false);
        });
    }
  };
  const handleSubmitUpload = (values) => {
    setActionLoading(true);
    const formData = new FormData();
    let keys = Object.keys(values);
    keys.map((item) => {
      if (item !== "image") {
        formData.append(item, values[`${item}`] || "");
      }
    });
    formData.append(
      "image",
      values.image ? values.image[0]?.originFileObj : ""
    );
      formData.append("id", id);
      formData.append("name", data.name);
      formData.append("registerno", data.registerno);
      axios({
        method: "put",
        url: `/customer`,
        headers: { "Content-Type": "multipart/form-data" },
        data: formData
      })
        .then((res) => {
          getData();
          handleCancel();
          setshowUploadModal(false)
        })
        .catch((err) => {})
        .finally(() => {
          setActionLoading(false);
        });
  };

  const handleAddButton = (data) => {
    setEditData(null);
    setShowModal(true);
  };


  const handleEditButton = (data) => {
    setEditData(data);
    setShowModal(true);
  };

  const handleDelete = (data) => {
    setActionLoading(true);
    axios({
      method: "delete",
      url: `/order/${data.id}`,
    })
      .then((res) => {
        getData();
        handleCancel();
      })
      .catch((err) => {})
      .finally(() => {
        setActionLoading(false);
      });
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleCancel = () => {
    setShowModal(false);
    if (editData) {
      setEditData(null);
    } else {
      form.resetFields();
    }
  };

  const handleUploadImage = (data) => {
    setEditData(null);
    setshowUploadModal(true);
  };
  const handleUploadImageCancel = () => {
    setshowUploadModal(false);
    if (editData) {
      setEditData(null);
    } else {
      form.resetFields();
    }
  };
  const handleCloseModalUpload = () => {
    setshowUploadModal(false);
  };
  const handleImageChange = ({ fileList }) => {
    form.setFieldsValue({ image: fileList }); 
  };
  return (
    <div className='mainCard px-10 '>
        <div className='border drop-shadow-lg w-full border-gray-200 bg-white py-4 px-6 rounded-3xl mb-10'>
        <div className="flex font-sans ">
          <div className="flex-none w-60 relative mr-4">
            <img 
               src={`${process.env.REACT_APP_CDN_URL}${data.image}`}  
              alt="" className="absolute inset-0 w-full h-full object-cover " loading="lazy" />
          </div>
          <div className="flex-auto p-6">
            <div className="flex flex-wrap">
              <div className="w-full flex-none text-lg font-semibold text-slate-900">
                Нэр: {data.name}
                {/* {id}  */}
              </div>
              <div className="w-full flex-none text-sm font-medium text-slate-700 mt-2">
                Утас: {data.phone}
                {/* {location.state.sku} */}
              </div>
              <div className="w-full flex-none text-sm font-medium text-slate-700 mt-2">
                Мэйл: {data.email}
                {/* {location.state.sku} */}
              </div>
            </div>
            <div className="flex items-baseline mt-4 mb-6 pb-6 border-b border-slate-200">
              <div className="space-x-2 flex text-sm">
                <label>
                  <input className="sr-only peer" name="size" type="radio" value="xs" checked />
                  <div className="text-base">
                  </div>
                </label>
              </div>
            </div> 
            <div>
              <div className="text-sm font-medium text-slate-700 mt-2">РД: {data.registerno}</div>
              <div className="text-sm font-medium text-slate-700 mt-2">Хаяг:</div>
              {data.address}
            </div>
          </div>
          {/* Edit Button */}
          <div className="flex-none">
            <Button className="text-sm text-slate-700 hover:text-slate-900 focus:outline-none" 
            onClick={()=>handleUploadImage()}
            >
              Зураг солих
            </Button>
          </div>
        </div>
      </div>

    <TableCard
      header={
        <div className="flex flex-col">
          <div className="w-full flex justify-between items-center gap-4">
            <h1 className="text-2xl font-medium">Харилцагчийн түүх</h1>
            <div className="flex items-center gap-2">
              {/* <Button icon={<FaDownload />} onClick={() => {}}>
                Татах
              </Button> */}
              <Export
                fileData={data.orders} 
                fileName={'ХарилцагчийнТүүх'} 
              />
              {/* <Button
                type="primary"
                icon={<FaPlus />}
                onClick={handleAddButton}
              >
                Нэмэх
              </Button> */}
            </div>
          </div>
        </div>
      }
    >
      <Table dataSource={data.orders} columns={columns} loading={loading} />
      <Modal
        style={{ maxWidth: "80%", minWidth: "70%" }}
        title={editData ? "Засах" : "Шинээр нэмэх"}
        open={showModal}
        onCancel={handleCloseModal}
      >
        <Form
          form={form}
          fields={fields}
          editData={editData}
          onFinish={handleSubmit}
          className={"gap-2"}
        >
          <div className="col-span-12 flex justify-end items-center gap-2 mt-5">
            <Button
              type="primary"
              onClick={() => form.submit()}
              loading={actionLoading}
              icon={<SaveOutlined />}
            >
              Хадгалах
            </Button>
            <Button onClick={handleCancel} disabled={actionLoading}>
              Цуцлах
            </Button>
          </div>
        </Form>
      </Modal>
      <Modal
        title={"Зураг оруулах"}
        open={showUploadModal}
        onCancel={handleCloseModalUpload}
      >
        <Form
          form={form}
          // fields={fieldsUpload}
          editData={editData}
          onFinish={handleSubmitUpload}
          className={"gap-2"}
        >
           <Form.Item
                className='col-span-12 mb-0 grid place-items-center'
                name='image'
              >
              <ImgCrop>
                <Upload name="image" beforeUpload={() => false} type="drag" listType="picture" 
                    maxCount={1} 
                    fileList={form.getFieldValue("image")} 
                    onChange={handleImageChange}
                    >
                    <div className="flex flex justify-center">
                    <img src={`${process.env.REACT_APP_CDN_IMG}${data?.image}`} width={240} height={240} className='rounded-full'/>
                    </div>
                    <div className='absolute bottom-0 left-0 right-0 top-0 rounded-full w-full h-full opacity-50 bg-black'></div>
                    <div className='absolute bottom-0 left-0 right-0 top-0 grid place-items-center'>
                      <label className='border border-white rounded-2xl px-4 py-2 text-white text-xl font-medium cursor-pointer' for="logo">Зураг солих</label>
                    </div>           
                </Upload>
             </ImgCrop>
            </Form.Item>
          <div className="col-span-12 flex justify-end items-center gap-2 mt-5">
            <Button
              type="primary"
              onClick={() => form.submit()}
              loading={actionLoading}
              icon={<SaveOutlined />}
            >
              Хадгалах
            </Button>
            <Button onClick={handleCloseModalUpload} disabled={actionLoading}>
              Цуцлах
            </Button>
          </div>
        </Form>
      </Modal>
      
    </TableCard>
    </div>
  );
}

export default Costumer_Detail;
